import * as tslib_1 from "tslib";
import { EventEmitter, NgZone, OnInit } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import { PropertyViewService } from "@app/features/customers/customer/property-view/service/property-view.service";
import { ReplaySubject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AuthService } from "@app/core";
import { CommonService } from "@app/services";
var CallLogModalComponent = /** @class */ (function () {
    function CallLogModalComponent(fb, opportunityService, zone, confirmationBoxHelper, ajsScope, propertyviewservice, authService, commonService) {
        var _this = this;
        this.fb = fb;
        this.opportunityService = opportunityService;
        this.zone = zone;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.ajsScope = ajsScope;
        this.propertyviewservice = propertyviewservice;
        this.authService = authService;
        this.commonService = commonService;
        this.callType = [{ id: 'Incoming Call', value: 'Inbound call' }, { id: 'Outgoing Call', value: 'Outbound call' }];
        this.scheduled = true;
        this.callActivityShow = false;
        this.activityIsScheduled = [];
        this.completed = true;
        this.saveDisabled = false;
        this.isContactNotFound = false;
        this.showCallLogModal = false;
        this.onSave = new EventEmitter();
        this.onClose = new EventEmitter();
        this.isCommonRoute = false;
        this.customTagsList = [];
        this.selectedUsersList = [];
        this.users = [];
        this.isAssigned = false;
        this.subscriptions = new Subscription();
        this.destroyed$ = new ReplaySubject(1);
        this.previouslySelectedUsers = [];
        this.onChange = function () {
            var message = _this.callForm.value.note;
            _this.customTagsList.forEach(function (ct) {
                if (!message.includes(">{" + ct.name + "}</") && !_this.customTagForm.controls[ct.name].value) {
                    _this.customTagForm.controls[ct.name].setValidators(Validators.nullValidator);
                    _this.customTagForm.controls[ct.name].disable();
                }
            });
        };
    }
    CallLogModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.usersWritePermission = this.authService.permitted(['SetupJobUsers.writeaccess']) === true;
        this.usersUpdatePermission = this.authService.permitted(['SetupJobUsers.updateaccess']) === true;
        if (this.usersList && this.usersList.length) {
            this.setUserList(this.usersList);
        }
        var users = this.propertyviewservice.timelineDetails$.pipe(takeUntil(this.destroyed$)).subscribe(function (data) {
            if (data && data.hasOwnProperty('assignee')) {
                var assignee = data.assignee ? data.assignee : [];
                _this.setUserList(assignee);
            }
            else if (!_this.usersList || _this.usersList.length === 0) {
                _this.commonService.getUsersList().subscribe(function (res) {
                    _this.setUserList(res.userRecords);
                });
            }
        });
        this.subscriptions.add(users);
    };
    CallLogModalComponent.prototype.ngOnChanges = function (changes) {
        var _this = this;
        if (changes.usersList && changes.usersList.currentValue && changes.usersList.currentValue.length) {
            this.setUserList(changes.usersList.currentValue);
        }
        if (changes.showCallLogModal) {
            if (this.showCallLogModal) {
                if (this.editCallData == null) {
                    var showContent = 'call';
                    if (this.activityList) {
                        /* for (var filter = 0; filter < this.activityList.length; filter++) {
                             // for (var record = 0; record < this.activityList[filter]['records'].length; record++) {
                                 if (this.activityList[filter]['isScheduled'] == 'true' && this.activityList[filter]['activityStatus'] != 'Completed'
                                     && this.activityList[filter]['activityType'].toLowerCase() == showContent.toLowerCase())
                                     this.activityIsScheduled.push(this.activityList[filter])
                             // }
                         }*/
                        if (this.activityList.length != 0 && this.activityList[0].length != 0) {
                            this.callActivityShow = true;
                            this.completed = true;
                        }
                        else {
                            this.callActivityShow = false;
                            this.completed = false;
                        }
                    }
                    this.buildForm();
                    if (!this.isCommonRoute) {
                        setTimeout(function () {
                            _this.todayActivity();
                        }, 500);
                    }
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.callLogModal').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                    setTimeout(function () {
                        // this.updateTinyMCEValues();
                    }, 100);
                }
                else {
                    if (this.editCallData['activityType'] == 'Call') {
                        this.editId = this.editCallData.communications.phoneId;
                        this.callActivityShow = false;
                        this.buildForm();
                        this.callForm.patchValue({
                            "contactTelephoneId": this.editCallData.communications.contactNumberId,
                            "note": this.editCallData.communications.phoneCallNote,
                            "callType": this.editCallData.communications.calltype
                        });
                        $(".modal-header").css("background", "#5E6D7F");
                        $('#modalPopUp').modal('show');
                        // $(".modal-dialog").css("height", "450px");
                        $(".modal-dialog").addClass("modal-dialog-open");
                        $('.callLogModal').addClass('in');
                        setTimeout(function () {
                            // this.updateTinyMCEValues();
                        }, 100);
                    }
                }
            }
        }
        if (changes.customerId && this.customerId) {
            this.getCustomerCall();
        }
    };
    CallLogModalComponent.prototype.getCustomerCall = function () {
        var _this = this;
        if (this.isCommonRoute) {
            this.opportunityService.getTimelineContacts(this.customerId, this.customerType, this.tablePKId, this.screenType).subscribe(function (data) {
                if (Object.values(data).length) {
                    _this.customerCallDetails = Object.values(data);
                }
                else {
                    _this.isContactNotFound = true;
                }
            });
        }
        else {
            this.opportunityService.getCustomerContact(this.customerId).subscribe(function (data) {
                if (Object.values(data).length) {
                    _this.customerCallDetails = data;
                }
                else {
                    _this.isContactNotFound = true;
                }
            });
        }
    };
    CallLogModalComponent.prototype.buildForm = function () {
        this.callForm = this.fb.group({
            "contactTelephoneId": ["", Validators.required],
            "activityType": ["Call"],
            "note": [""],
            "customerId": [""],
            "callType": ["Outgoing Call", Validators.required]
        });
    };
    CallLogModalComponent.prototype.closeModal = function (emitEvent) {
        var _this = this;
        if (emitEvent === void 0) { emitEvent = true; }
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the log call?', this.ajsScope)
            .then(function () {
            _this.closeModalWithoutConfirmation(emitEvent);
        }).catch(function () { });
    };
    CallLogModalComponent.prototype.closeModalWithoutConfirmation = function (emitEvent) {
        if (emitEvent === void 0) { emitEvent = true; }
        this.editId = null;
        this.callForm.controls['activityType'].setValue('');
        this.callForm.controls['customerId'].setValue('');
        this.callForm.controls['note'].setValue('');
        this.editCallData = undefined;
        this.scheduledData = undefined;
        this.scheduled = false;
        this.activityIsScheduled = [];
        $('.callLogModal').modal('hide');
        $("#call-log-modal-dialogue").removeClass("modal-dialog-open");
        if (emitEvent)
            this.onClose.emit(false);
    };
    CallLogModalComponent.prototype.isScheduledActivity = function (event) {
        this.scheduled = event.target.checked;
    };
    CallLogModalComponent.prototype.completeActivity = function (event) {
        this.completed = event.target.checked;
    };
    CallLogModalComponent.prototype.todayActivity = function () {
        var _this = this;
        this.opportunityService.getScheduledEmail(this.opportunityId, 'Call').subscribe(function (resp) {
            if (resp) {
                if (resp == false) {
                    _this.callActivityShow = false;
                    _this.completed = false;
                }
                else {
                    _this.callActivityShow = true;
                    _this.completed = true;
                    _this.todayActivityId = resp;
                }
            }
        });
    };
    CallLogModalComponent.prototype.saveCall = function () {
        var _this = this;
        if (this.isCommonRoute) {
            var callData = this.callForm.value;
            callData.editId = this.editId;
            if (this.selectedUsersList && this.selectedUsersList.length) {
                callData.selectedUsersList = this.selectedUsersList.map(function (x) { return x.id; });
                callData.isAssigned = this.isAssigned;
            }
            else {
                callData.selectedUsersList = [];
            }
            callData.isScheduled = this.scheduled;
            if (this.completed) {
                callData.activityIds = this.activityList[0];
            }
            if (this.editCallData) {
                callData.communicationId = this.editCallData.communications.communicationId;
            }
            this.onSave.emit(callData);
        }
        else {
            this.saveDisabled = true;
            this.callForm.get('customerId').setValue(this.customerId);
            var callData = this.callForm.value;
            if (this.completed) {
                callData = this.callForm.value;
                var activityId = this.todayActivityId;
                /*if (this.activityIsScheduled.length != 0) {
                    for (var i = 0; i < this.activityIsScheduled.length; i++) {
                        activityId.push(this.activityIsScheduled[i]['activity_id'])
                    }
                } else {
                    if (this.scheduledData) {
                        if (this.scheduledData.hasOwnProperty('activity_id')) {
                            activityId.push(this.scheduledData.activity_id)
                        } else {
                            activityId.push(this.scheduledData.activityId)
                        }
                    }
                }*/
                callData.activityIds = activityId;
            }
            // this.editId = event.editId;
            // callData.activityIds = this.activityEmail;
            var url = void 0;
            if (this.editId) {
                url = "sales/edit_opportunity_call/" + this.editId;
            }
            else {
                url = "sales/opportunityActivityCall/" + this.opportunityId;
            }
            this.opportunityService.createOpportunityCall(callData, url).subscribe(function (data) {
                // If this schedule, open the schedule activity modal
                _this.onSave.emit(_this.scheduled);
                _this.closeModalWithoutConfirmation();
                _this.saveDisabled = false;
                if (_this.scheduledData) {
                    if (_this.scheduledData.hasOwnProperty('activityId')) {
                        _this.opportunityService.refreshCompleteActivity('complete');
                    }
                }
            });
        }
    };
    // onChange = (_: any) => {
    //     const message = tinymce.get('email-template-message').getContent()
    //     this.callForm.patchValue({
    //         note: message
    //     });
    //     this.callForm.updateValueAndValidity();
    // };
    CallLogModalComponent.prototype.setUserList = function (assignee) {
        if (assignee) {
            this.usersList = assignee.map(function (x) {
                var displayName = (x.username && String(x.username).trim());
                return tslib_1.__assign({}, x, { value: displayName });
            }).filter(function (x) { return x && x.id != null && x.value !== ''; });
            if (this.editCallData) {
                var content = {
                    html: this.editCallData.communications.phoneCallNote
                };
                this.onContentChange(content, true);
            }
        }
    };
    CallLogModalComponent.prototype.onContentChange = function (event, getSelectedUsers) {
        var _this = this;
        if (getSelectedUsers === void 0) { getSelectedUsers = false; }
        if (event.text === '\n') {
            this.saveDisabled = true;
        }
        else {
            this.saveDisabled = false;
        }
        this.onChange();
        var contentEl = $(event.html).find('[data-denotation-char=""]');
        var userList = [];
        if (contentEl.length) {
            var _loop_1 = function (i) {
                var index = userList.findIndex(function (data) { return data.id == contentEl[i].dataset['id']; });
                if (index < 0) {
                    var user = this_1.usersList.find(function (data) { return data.id == contentEl[i].dataset['id']; });
                    userList.push(user);
                }
            };
            var this_1 = this;
            for (var i = 0; i < contentEl.length; i++) {
                _loop_1(i);
            }
        }
        this.selectedUsersList = [];
        if (userList.length && !getSelectedUsers) {
            // Removing the user from the selected list
            this.previouslySelectedUsers.forEach(function (user, index) {
                var checkPreviousIndex = userList.findIndex(function (data) { return data == user; });
                if (checkPreviousIndex === -1) {
                    _this.previouslySelectedUsers.splice(index, 1);
                }
            });
            // Checking if the user is already selected
            userList.forEach(function (user) {
                var checkPreviousIndex = _this.previouslySelectedUsers.findIndex(function (data) { return data == user; });
                if (checkPreviousIndex < 0) {
                    _this.selectedUsersList.push(user);
                }
            });
        }
        else {
            this.previouslySelectedUsers = userList;
        }
    };
    CallLogModalComponent.prototype.ngOnDestroy = function () {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    };
    return CallLogModalComponent;
}());
export { CallLogModalComponent };
